<div class="patient">
  <div class="wrapper">
    <!-- ========================== header (start) ========================== -->
    <app-page-header>
      <div
        class="l-header-panel"
        [ngClass]="
          loginService.isAdmin && !loginService.isCardio && !loginService.isGastro ? 'dsp-flex' : ''
        "
      >
        <div
          id="1"
          [ngClass]="
            reportList?.length || statisticsForDoctors?.length ? 'headerReports' : 'header'
          "
        >
          <h1 class="t-title-main" *ngIf="examList">
            {{ 'GUI.Patients.titles.Exams' | translate }}
          </h1>
          <h1 class="t-title-main" *ngIf="showPatientsTitle">
            {{ 'GUI.Patients.titles.Patients' | translate }}
          </h1>
          <h1 class="t-title-main" *ngIf="AWLlist">Today's List</h1>
          <h1 class="t-title-main" *ngIf="reportList || statisticsForDoctors">
            {{ 'GUI.Patients.titles.Reports' | translate }}
          </h1>
          <ng-container *ngFor="let examType of examTypeCounts | keyvalue">
            <h4>{{ examType.key }}: {{ examType.value }}</h4>
          </ng-container>
          <h4 *ngIf="reportList?.length">
            {{ 'GUI.Patients.titles.Number of Exams' | translate }}:
            {{ reportList.length }}
          </h4>
          <div>
            <span
              class="header-icon-btn header-icon-btn--sm icon-file"
              matTooltip="Download CVS"
              *ngIf="showIcons && reportList?.length"
              (click)="exportExcel()"
            ></span>
            <!-- <img
                   style="cursor: pointer ;margin-right: 0.5em; margin-left: 0.5em"
                   matTooltip="Print pdf"
                   *ngIf="showIcons"
                   (click)="getPDF()"
                  height="31em"
                  width="31em"
                  src="../../assets/icons/print.svg"
                /> -->
          </div>

          <div class="l-flex l-flex-c t-field t-field-pad" *ngIf="isAWL" style="margin-left: 2em">
            <label>
              {{ 'GUI.Patients.titles.Status' | translate }}
            </label>

            <i class="t-sep"></i>

            <select
              class="t-field t-select"
              [(ngModel)]="AWLStatus"
              (change)="AWL(); startdate = null; enddate = null"
            >
              <option value="All">
                {{ 'GUI.Patients.todaylist.statues.all' | translate }}
              </option>
              <option value="Waiting">
                {{ 'GUI.Patients.todaylist.statues.Waiting' | translate }}
              </option>
              <option value="In Progress">
                {{ 'GUI.Patients.todaylist.statues.In Progress' | translate }}
              </option>
              <option value="Completed">
                {{ 'GUI.Patients.todaylist.statues.Completed' | translate }}
              </option>
            </select>
          </div>
        </div>

        <button
          class="search-btn search-btn--newPatient"
          *ngIf="AWLlist && loginService.barcodeScan && !swiping"
          style="margin-left: auto; width: 8em"
          (click)="swiping = true; getcard()"
        >
          Scan barcode
        </button>

        <input
          *ngIf="AWLlist && loginService.barcodeScan && swiping"
          #swipeField
          (keyup)="barscan($event)"
          [(ngModel)]="card"
        />
        <nav class="on-mobile header-mobilePanel">
          <button
            class="btn-mobileMenu"
            id="open-mainNav"
            data-show=".l-sidebar"
            aria-label="open mobile sidebar"
          ></button>
        </nav>
        <div
          *ngIf="
            (loginService.isAdmin || loginService.userType === 'secretary') &&
            (loginService.separatedClinic || loginService.SeparateZimun) &&
            !loginService.isGastro &&
            !loginService.isCardio &&
            !loginService.ishospital
          "
          style="right: 4em"
        >
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label matTooltip="{{ 'GUI.Tooltips.Doctors Name' | translate }}">
              <img src="../../assets/icons/drb.svg" />
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1">
              <select
                [(ngModel)]="loginService.doctor"
                (ngModelChange)="AWL()"
                class="t-select w100"
                style="text-align: center"
              >
                <option [value]="null">All</option>
                <!-- <option *ngIf="awlExam && ! examTypes.includes(awlExam)" [value]="awlExam">{{awlExam}}</option> -->
                <ng-container *ngFor="let e of getDoctors()">
                  <option [value]="e.UID">{{ e.Name }}</option>
                </ng-container>
              </select>
            </span>
          </div>
        </div>
      </div>
    </app-page-header>
    <!-- ========================== header (end) ========================== -->

    <!-- ========================== intro (start) ========================== -->

    <main class="l-deashboard">
      <!-- ========================== Today's List Result (Start) ========================== -->
      <app-loading-spinner *ngIf="awlListLoading" [leaving]="awlListFading"></app-loading-spinner>
      <ng-container *ngIf="!awlListLoading">
        <div class="l-flex patient-item" *ngFor="let pat of AWLlist; index as i">
          <div class="w100 patient-item-link">
            <div class="l-table h100">
              <span
                class="l-td-m patient-item-cell patient-id"
                (click)="setAWL(pat); selectedPatient = pat"
              >
                {{ 'GUI.Patients.Time' | translate }}:
                <strong>{{
                  loginService.isCardio && AWLStatus === 'Completed'
                    ? (pat.ExamDate | date: 'd/M/yy, h:mm a')
                    : (pat.ExamDate | date: 'shortTime')
                }}</strong>
              </span>
              <span
                class="l-td-m patient-item-cell patient-id"
                (click)="setAWL(pat); selectedPatient = pat"
              >
                {{ 'GUI.Patients.ID' | translate }}: <strong>{{ pat.ID }}</strong>
              </span>
              <span
                class="l-td-m patient-item-cell patient-name-first"
                [ngClass]="pat.Reason ? 'type-v' : 'type-plus'"
                (click)="setAWL(pat); selectedPatient = pat"
              >
                {{ pat.First }} {{ pat.Last }}
                <span
                  class="anatomy-show-more"
                  style="bottom: auto; right: auto"
                  *ngIf="
                    (!loginService.ishospital || loginService.ishospital === 'belinson') &&
                    !loginService.isGastro
                  "
                >
                  <!--form elemnts not working when empty so using hack-->

                  <div class="on-hoverPanel">
                    <div class="on-hoverPanel-body">
                      <div class="anatomy-item-details">
                        <div class="anatomy-items-desc">
                          <div
                            class="anatomy-items-edited scroller mCustomScrollbar _mCS_2 mCS_no_scrollbar"
                            contenteditable="true"
                          >
                            <div
                              id="mCSB_2"
                              class="mCustomScrollBox mCS-light mCSB_vertical mCSB_inside"
                              tabindex="0"
                              style="max-height: none"
                            >
                              <div
                                id="mCSB_2_container"
                                class="mCSB_container mCS_y_hidden mCS_no_scrollbar_y"
                                style="position: relative; top: 0; left: 0"
                                dir="ltr"
                              ></div>
                              <div
                                id="mCSB_2_scrollbar_vertical"
                                class="mCSB_scrollTools mCSB_2_scrollbar mCS-light mCSB_scrollTools_vertical"
                                style="display: none"
                              >
                                <div class="mCSB_draggerContainer">
                                  <div
                                    id="mCSB_2_dragger_vertical"
                                    class="mCSB_dragger"
                                    style="
                                      position: absolute;
                                      min-height: 30px;
                                      top: 0px;
                                      display: block;
                                      height: 12px;
                                      max-height: 106.938px;
                                    "
                                  >
                                    <div class="mCSB_dragger_bar" style="line-height: 30px"></div>
                                  </div>
                                  <div class="mCSB_draggerRail"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <textarea
                            class="anatomy-items-edit"
                            (click)="$event.stopPropagation()"
                            (change)="saveComment(pat.Reason, pat.AWLID)"
                            [(ngModel)]="pat.Reason"
                          ></textarea>
                        </div>
                      </div>

                      <!--<button class="anatomy-details-save">Save Comments</button> -->
                    </div>
                  </div>
                </span>
              </span>
              <span
                class="l-td-m patient-item-cell patient-name-first"
                *ngIf="loginService.hasSurrogatePreg"
                (click)="setAWL(pat); selectedPatient = pat"
              >
                {{ pat.Surrogate ? pat.Surrogate : '' }}
              </span>
              <span
                class="l-td-m patient-item-cell patient-name-first"
                *ngIf="(!loginService.ishospital || loginService.AWLExamNames) && pat.ExamCode"
              >
                {{ pat.ExamCode }}
                <ng-container *ngIf="loginService.premissions?.Consent">
                  <span style="position: relative; display: inline-block">
                    <img
                      src="../../assets/icons/login/text-file-icon.svg"
                      style="height: 1.5em; width: 1.5em; cursor: pointer"
                      matTooltip="{{ 'GUI.Tooltips.Open Consent Form' | translate }}"
                      (click)="$event.stopPropagation(); openConsentModal(pat)"
                    />
                    <span
                      *ngIf="patConsentSigned[pat.AWLID]"
                      style="
                        position: absolute;
                        bottom: -0.1em;
                        right: -0.4em;
                        font-size: 0.75em;
                        color: green;
                        font-weight: bold;
                        background: white;
                        border-radius: 50%;
                        line-height: 1;
                        padding: 0 1px;
                      "
                      >✓</span
                    >
                  </span>
                </ng-container>
                <ng-container *ngIf="loginService.premissions?.Questionnaires">
                  <span style="position: relative; display: inline-block">
                    <img
                      src="../../assets/icons/phone-mobile.svg"
                      style="
                        height: 1.5em;
                        width: 1.5em;
                        cursor: pointer;
                        margin-inline-start: 0.3em;
                      "
                      matTooltip="{{ 'GUI.Tooltips.Send Questionnaire' | translate }}"
                      (click)="$event.stopPropagation(); openSendQuestionnaire(pat)"
                    />
                    <span
                      *ngIf="patQuestionnaireAnswered[pat.AWLID]"
                      style="
                        position: absolute;
                        bottom: -0.1em;
                        right: -0.4em;
                        font-size: 0.75em;
                        color: green;
                        font-weight: bold;
                        background: white;
                        border-radius: 50%;
                        line-height: 1;
                        padding: 0 1px;
                      "
                      >✓</span
                    >
                  </span>
                </ng-container>
              </span>
              <span
                class="l-td-m patient-item-cell patient-name-first"
                *ngIf="
                  (!loginService.ishospital || loginService.AWLExamNames) &&
                  !pat.ExamCode &&
                  loginService.isCardio
                "
              >
                <select
                  class="t-field t-select"
                  [(ngModel)]="changedExamCode"
                  (ngModelChange)="setExamCode(pat)"
                >
                  <option *ngFor="let name of cardioTodayListExams" [value]="name">
                    {{ name }}
                  </option>
                </select>
              </span>
              <span
                class="l-td-m patient-item-cell patient-name-first"
                *ngIf="
                  loginService.separatedClinic &&
                  (loginService.isAdmin || loginService.userType === 'secretary')
                "
              >
                {{ loginService.getDocByUID(pat.UID) }}
              </span>
              <span
                class="l-td-m patient-item-cell patient-name-first"
                *ngIf="!loginService.ishospital && !loginService.isCardio && !loginService.isGastro"
                (click)="setAWL(pat); selectedPatient = pat"
              >
                {{
                  pat.ExamLMP
                    ? ('GUI.Patients.LMP' | translate) + ': ' + (pat.ExamLMP | date: 'd.M.yyyy')
                    : ''
                }}
                {{ GaArray ? ('GUI.Patients.GA' | translate) + ': ' + GaArray[i] : '-1w -1d' }}
              </span>
              <span
                class="l-td-m patient-item-cell patient-name-first"
                (click)="setAWL(pat); selectedPatient = pat"
              >
                <!-- {{getStatus(pat.Status)}} -->
                {{ 'GUI.Patients.todaylist.statues.' + getStatus(pat.Status) | translate }}
              </span>
            </div>
          </div>
          <a
            class="l-td-m patient-item-exit"
            routerLink="/exams"
            (click)="patservice.setPat(pat); setPatAwlid(pat)"
            [state]="{ data: pat }"
          ></a>
        </div>

        <!-- Today's List: empty — reflects the current status filter -->
        <div class="no-results" *ngIf="AWLlist && AWLlist.length === 0">
          <ng-container *ngIf="AWLStatus && AWLStatus !== 'All'; else allEmpty">
            {{
              'GUI.Patients.empty.today status'
                | translate: { status: 'GUI.Patients.todaylist.statues.' + AWLStatus | translate }
            }}
          </ng-container>
          <ng-template #allEmpty>{{ 'GUI.Patients.empty.today' | translate }}</ng-template>
        </div>
      </ng-container>

      <!-- ========================== Patients Search (Start) ========================== -->
      <app-loading-spinner *ngIf="patListLoading" [leaving]="patListFading"></app-loading-spinner>
      <ng-container *ngIf="!patListLoading">
        <!-- ======= Patient Results Pagination Top (Start) ======= -->
        @if (showPatientPager) {
        <app-pagination-controls
          [total]="totalResults"
          [page]="currentPage"
          [totalPages]="totalPages"
          (prev)="previousPage()"
          (next)="nextPage()"
        ></app-pagination-controls>
        }
        <!-- ======= Patient Results Pagination Top (End) ======= -->
        <div class="l-flex patient-item" *ngFor="let pat of patList">
          <button
            class="w100 patient-item-link"
            (click)="selectedPatient = pat"
            [matTooltip]="'GUI.Tooltips.Open Patient Record' | translate | titlecase"
          >
            <div class="l-table h100">
              <span class="l-td-m patient-item-cell patient-id">
                {{
                  pat.IsID
                    ? ('GUI.Patients.ID' | translate)
                    : ('GUI.Patients.Passport' | translate)
                }}:
                <strong>
                  {{ pat.ID }}
                </strong>
              </span>

              <span class="l-td-m patient-item-cell patient-name-first">
                {{ pat.First }}
              </span>

              <span class="l-td-m patient-item-cell patient-name-last">
                {{ pat.Last }}
              </span>
              <span
                class="l-td-m patient-item-cell patient-name-first"
                *ngIf="
                  loginService.separatedClinic &&
                  (loginService.isAdmin || loginService.userType === 'secretary')
                "
              >
                {{ loginService.getDocByUID(pat.UID) }}
              </span>
            </div>
          </button>
          <a
            class="l-td-m patient-item-exit"
            routerLink="/exams"
            (click)="patservice.setPat(pat)"
            [state]="{ data: pat }"
            [matTooltip]="'GUI.Tooltips.Open Patient History' | translate | titlecase"
          ></a>
        </div>
        <!-- Patient search: no matches -->
        <div class="no-results" *ngIf="patList && patList.length === 0">
          {{ 'GUI.Patients.empty.patients' | translate }}
        </div>
        <!-- ======= Patient Results Pagination Bottom (Start) ======= -->
        @if (showBottomPatientPager) {
        <app-pagination-controls
          [total]="totalResults"
          [page]="currentPage"
          [totalPages]="totalPages"
          (prev)="previousPage()"
          (next)="nextPage()"
        ></app-pagination-controls>
        }
        <!-- ======= Patient Results Pagination Bottom (End) ======= -->
      </ng-container>
      <!-- ========================== Patients Search (End) ========================== -->
      <!-- report list -->
      <div *ngIf="reportList">
        <h1 *ngIf="withoutPrn && reportList.length">
          Exams without PRNs for the period starting on
          {{ reportList[0].from | date: 'd/M/yyyy' }} and ending on
          {{ reportList[0].until | date: 'd/M/yyyy' }}
        </h1>
        <h1 *ngIf="!withoutPrn && reportList.length">
          Exams sent to Leumit for the period starting on
          {{ reportList[0].from | date: 'd/M/yyyy' }} and ending on
          {{ reportList[0].until | date: 'd/M/yyyy' }}
        </h1>
        <div *ngFor="let examType of reportList | map: 'ExamType' | set | toArray">
          <h4>{{ examType }}</h4>
          <div
            class="l-flex patient-item"
            *ngFor="let exam of reportList | filter: { ExamType: examType }"
          >
            <!-- matTooltip="Click to View Patient History" -->
            <!-- (click)="goPatient(exam.PID) -->

            <button class="w100" style="cursor: default">
              <div class="l-table h100">
                <span class="l-td-m patient-item-cell patient-name-first">
                  Exam Time: <strong>{{ exam.CreationTime | date: 'dd/MM/yyyy h:mm a' }}</strong>
                </span>
                <span class="l-td-m patient-item-cell patient-id">
                  ID: <strong>{{ exam.ID }}</strong>
                </span>

                <span class="l-td-m patient-item-cell patient-id">
                  Name: {{ exam.First }} {{ exam.Last }}
                </span>

                <span class="l-td-m patient-item-cell patient-name-first">
                  Exam Type: <strong>{{ exam.ExamType }} </strong>
                </span>
                <span class="l-td-m patient-item-cell patient-name-first">
                  Performed By : <strong>{{ exam.Opener }} </strong>
                </span>
              </div>
            </button>
            <!-- <a class="l-td-m patient-item-exit" [ngClass]="getLocked(exam)" (click)="goExam(exam)" [matTooltip]="(getLocked(exam) === 'locked' ) ? 'Locked By: ' +exam.LockedBy : 'View Exam'"></a> -->
          </div>
        </div>
      </div>

      <!--  exam  list-->
      <app-loading-spinner *ngIf="examListLoading" [leaving]="examListFading"></app-loading-spinner>
      <ng-container *ngIf="!examListLoading">
        <!-- ======= Exam Results Pagination Top (Start) ======= -->
        <app-pagination-controls
          *ngIf="showExamPager"
          [total]="examTotal"
          [page]="examPage"
          [totalPages]="examTotalPages"
          (prev)="previousExamPage()"
          (next)="nextExamPage()"
        ></app-pagination-controls>
        <!-- ======= Exam Results Pagination (End) ======= -->
        <div class="l-flex patient-item" *ngFor="let exam of examList">
          <button
            class="w100 patient-item-link"
            (click)="goPatient(exam.PID)"
            matTooltip="{{ 'GUI.Tooltips.Click to View Patient History' | translate }}"
          >
            <div class="l-table h100">
              <span class="l-td-m patient-item-cell patient-name-first">
                Exam Time: <strong>{{ exam.CreationTime | date: 'dd/MM/yyyy h:mm a' }}</strong>
              </span>
              <span class="l-td-m patient-item-cell patient-id">
                ID: <strong>{{ exam.ID }}</strong>
              </span>

              <span class="l-td-m patient-item-cell patient-id">
                Name: {{ exam.First }} {{ exam.Last }}
              </span>

              <span class="l-td-m patient-item-cell patient-name-first">
                Exam Type:
                <strong
                  >{{ exam.ExamType }}
                  <span *ngIf="exam.Changed">({{ exam.ChangedExamTitle }})</span></strong
                >
              </span>
            </div>
          </button>
          <a
            class="l-td-m patient-item-exit"
            [ngClass]="getLocked(exam)"
            (click)="goExam(exam)"
            [matTooltip]="
              getLocked(exam) === 'locked'
                ? ('GUI.Tooltips.Locked By' | translate) + exam.LockedBy
                : ('GUI.Tooltips.View Exam' | translate)
            "
          ></a>
        </div>

        <!-- Exam search: no matches -->
        <div class="no-results" *ngIf="examList && examList.length === 0">
          {{ 'GUI.Patients.empty.exams' | translate }}
        </div>
        <!-- ======= Exam Results Pagination Bottom (Start) ======= -->
        @if (showBottomExamPager) {
        <app-pagination-controls
          [total]="examTotal"
          [page]="examPage"
          [totalPages]="examTotalPages"
          (prev)="previousExamPage()"
          (next)="nextExamPage()"
        ></app-pagination-controls>
        }
        <!-- ======= Exam Results Pagination Bottom (End) ======= -->
      </ng-container>

      <!-- =================================statisticsForDoctors of leumit (start) ==============================================================-->
      <ng-container *ngIf="statisticsForDoctors">
        <div *ngFor="let details of statisticsForDoctors" id="statistic">
          <h1>
            Exams Distribution by HMO’s for the period starting on
            {{ details.from | date: 'd/M/yyyy' }} and ending on
            {{ details.until | date: 'd/M/yyyy' }} for doctor
            {{ details.englishName || details.name }}:
          </h1>
          <table>
            <thead>
              <tr>
                <th>Patient Category</th>
                <th># of Exams</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Leumit with PRN</td>
                <td>{{ details.leumitWithPrn }}</td>
              </tr>
              <tr>
                <td>Leumit without PRN</td>
                <td>{{ details.leumitWithoutPrn }}</td>
              </tr>
              <tr>
                <td>Leumit Total</td>
                <td>{{ details.totalExamsForLeumit }}</td>
              </tr>
              <tr>
                <td>By other HMO’s</td>
                <td>{{ details.otherHmo }}</td>
              </tr>
              <tr>
                <td>No HMO indication</td>
                <td>{{ details.notRecognizeHmo }}</td>
              </tr>
              <tr>
                <td>Total exams performed</td>
                <td>{{ details.totalExams }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>

      <!-- =================================statisticsForDoctors of leumit (end)  ==============================================================-->
    </main>

    <app-bottombar></app-bottombar>
  </div>
  <!-- end wrapper -->

  <!-- ===================================== POPUP : HELP (START) =============================================== -->

  <div class="t-popup popup-help" *ngIf="showhelp">
    <div class="t-popup-close"></div>

    <div class="t-popup-frame">
      <div class="t-popup-body">
        <button
          class="t-btn-popup-close"
          aria-label="close popup"
          (click)="showhelp = false"
        ></button>

        <h2>Help</h2>

        <section class="part-help">
          <h3>Search</h3>

          It is a long established fact that a reader will be distracted by the readable content of
          a page when looking at its layout. The point of using Lorem Ipsum is that it has a
          more-or-less normal distribution of letters, as opposed to using 'Content here, content
          here', making it look like readable English. Many desktop publishing packages and web page
          editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum'
          will uncover many web sites still in their infancy. Various versions have evolved over the
          years, sometimes by accident, sometimes on purpose (injected humour and the like).
        </section>
      </div>
    </div>
  </div>
  <div class="t-popup popup-help" *ngIf="carderror" style="display: inherit">
    <div class="t-popup-close"></div>

    <div class="t-popup-frame">
      <div class="t-popup-body">
        <button
          class="t-btn-popup-close"
          aria-label="close popup"
          (click)="carderror = null"
        ></button>

        <h2 style="direction: rtl; margin-right: 3em">
          מטופל עם ת.ז. {{ carderror }} לא נמצאה ברשימת המוזמנים להיום.
        </h2>

        <section class="part-help">
          <h3 style="direction: rtl">נא לבדוק נכונות המספר ולנסות שוב</h3>
        </section>
      </div>
    </div>
  </div>

  <app-informconcent
    *ngIf="inform"
    (closed)="closCalForm($event)"
    [pat]="exServ.patServ.getPat()"
    [form]="concentForm"
  ></app-informconcent>

  <app-gyn-consent
    *ngIf="showGynConsent"
    (closed)="closeGynConsent($event)"
    [form]="concentForm"
    [ExamType]="'Gynecology'"
    [consentType]="selectedGynConsentType"
  ></app-gyn-consent>

  <div *ngIf="showConsentModal" class="print-history-popup">
    <div class="print-history-popup-body">
      <h2 class="popup-title">Consent Form</h2>
      <button
        (click)="showConsentModal = false"
        class="print-history-popup-close"
        aria-label="close popup"
      ></button>
      <div>
        <div class="l-flex-c l-flex-w l-justify h50 placenta-row" style="margin-top: 1em">
          <label class="t-label-top">
            <span>Exam Type</span>
            <select
              class="t-select t-field"
              [(ngModel)]="consentExamType"
              (change)="selectedGynConsentType = ''"
            >
              <option value="" disabled>Select Exam Type</option>
              <option value="1st">{{ 'GUI.Patient History.ExamTypes.OB.1st' | translate }}</option>
              <option value="NT">{{ 'GUI.Patient History.ExamTypes.OB.NT' | translate }}</option>
              <option value="Early">
                {{ 'GUI.Patient History.ExamTypes.OB.Early' | translate }}
              </option>
              <option value="2nd/3rd">
                {{ 'GUI.Patient History.ExamTypes.OB.2nd/3rd' | translate }}
              </option>
              <option value="Weight Assessment">
                {{ 'GUI.Patient History.ExamTypes.OB.Weight Assessment' | translate }}
              </option>
              <option value="Late">
                {{ 'GUI.Patient History.ExamTypes.OB.Late' | translate }}
              </option>
              <option *ngIf="loginService.premissions?.thirdScan" value="Third Scan">
                {{ 'GUI.Patient History.ExamTypes.OB.Third Scan' | translate }}
              </option>
              <option value="Specialized">
                {{ 'GUI.Patient History.ExamTypes.OB.Specialized' | translate }}
              </option>
              <option value="Fetal Echo">
                {{ 'GUI.Patient History.ExamTypes.OB.Fetal Echo' | translate }}
              </option>
              <option value="Gynecology">Gynecology</option>
            </select>
          </label>
        </div>
        <div
          class="l-flex-c l-flex-w l-justify h50 placenta-row"
          style="margin-top: 1em"
          *ngIf="consentExamType === 'Gynecology'"
        >
          <label class="t-label-top">
            <span>Consent Type</span>
            <select class="t-select t-field" [(ngModel)]="selectedGynConsentType">
              <option value="" disabled>Select Consent Type</option>
              <option value="Hysterosalpingo Sonography">Hysterosalpingo Sonography</option>
              <option value="Insertion of IUD">Insertion of IUD</option>
            </select>
          </label>
        </div>
        <!-- Dropdown: multiple practitioners, secretary only -->
        <div
          class="l-flex-c l-flex-w l-justify h50 placenta-row"
          style="margin-top: 1em"
          *ngIf="
            clinicPractitioners?.length > 1 &&
            !loginService.separatedClinic &&
            loginService.userType !== 'doctor'
          "
        >
          <label class="t-label-top">
            <span>Clinic's US Practitioners</span>
            <select
              class="t-select t-field"
              [(ngModel)]="consentPractitionerObj"
              (ngModelChange)="
                exServ.consentPractitioner = $event?.Title + ' ' + $event?.Name; setConsentDocUID()
              "
            >
              <option [ngValue]="null"></option>
              <ng-container *ngFor="let option of clinicPractitioners">
                <option [ngValue]="option">{{ option.Title }} {{ option.Name }}</option>
              </ng-container>
            </select>
          </label>
        </div>
        <!-- Read-only: doctor user -->
        <div
          class="l-flex-c l-flex-w l-justify h50 placenta-row"
          style="margin-top: 1em"
          *ngIf="loginService.userType === 'doctor'"
        >
          <label class="t-label-top">
            <span>Doctor</span>
            <span
              class="t-field"
              style="
                display: inline-block;
                padding: 0.4em 0.6em;
                background: #f5f5f5;
                border-radius: 4px;
              "
            >
              {{ loginService.username }}
            </span>
          </label>
        </div>
        <!-- Read-only: single practitioner, secretary -->
        <div
          class="l-flex-c l-flex-w l-justify h50 placenta-row"
          style="margin-top: 1em"
          *ngIf="
            loginService.userType !== 'doctor' &&
            (clinicPractitioners?.length === 1 || loginService.separatedClinic) &&
            clinicPractitioners?.length > 0
          "
        >
          <label class="t-label-top">
            <span>Doctor</span>
            <span
              class="t-field"
              style="
                display: inline-block;
                padding: 0.4em 0.6em;
                background: #f5f5f5;
                border-radius: 4px;
              "
            >
              {{ consentPractitionerObj?.Title }} {{ consentPractitionerObj?.Name }}
            </span>
          </label>
        </div>
        <div style="display: flex; justify-content: space-around; margin-top: 1.5em">
          <button
            class="orange-btn"
            (click)="confirmConsentModal()"
            [disabled]="
              !consentExamType || (consentExamType === 'Gynecology' && !selectedGynConsentType)
            "
          >
            Open Form
          </button>
        </div>
      </div>
    </div>
  </div>

  <app-loginbox
    *ngIf="showLogin"
    (closed)="showLogin = false"
    (viewonly)="viewonly()"
    [isnew]="false"
  ></app-loginbox>
  <app-patdetails
    *ngIf="selectedPatient && !typeForm"
    [pat]="selectedPatient"
    [awl]="chosenAWL"
    [awlExam]="awlExamType"
    [awlTime]="awlTime"
    [awlLMP]="awlLMP"
    [awlComment]="awlComment"
    [openWAWL]="loginService.barcodeScan"
    (closed)="onClosed($event)"
    (showpay)="paymentNoCard()"
    (show_surrogate)="show_surrogate = true"
  ></app-patdetails>
  <app-surrogate
    *ngIf="show_surrogate"
    (closed)="show_surrogate = false"
    [genMom]="selectedPatient"
  ></app-surrogate>
  <app-payment
    *ngIf="showpayment"
    [tz]="showpayment"
    [idtype]="idcode"
    [awlid]="selectedPatient.AWLID"
    [exp]="expcode"
    (closed)="showpayment = null"
  ></app-payment>
  <app-searchbox
    *ngIf="openEsearch"
    (closed)="searchClosed($event)"
    [isReports]="isReports"
    [hmostype]="hmostype"
    [isGastro]="loginService.isGastro"
    [startdate]="fromd"
    [enddate]="tod"
    [examtype]="examMode"
    [exams]="examVals"
  ></app-searchbox>
  <app-commerror></app-commerror>
  <app-printopts
    *ngIf="showprint"
    (closed)="showprint = false"
    [showopts]="showprintopts"
    [stats]="true"
    [isReport]="true"
    [type]="reportName"
    [startdate]="fromd"
    [enddate]="tod"
    [hmostype]="hmostype"
  >
  </app-printopts>
  <app-send-questionnaire
    *ngIf="showSendQuestionnaire"
    [patient]="sendQuestionnairePatient"
    (closed)="showSendQuestionnaire = false; selectedPatient = null"
  ></app-send-questionnaire>
</div>
